<template>
    <div class="form-wrapper">
        <!--render a single field-->
        <transition-group name="slide-fade">
            <div class="field-wrapper" v-for="field in formdef" v-show="field_shown(field)" :id="'field_'+field.name" :class="{inset:field.depends, error:errors[field.name]}" :key="field.name">
                <label>{{field.label}}<template v-if="field.required">*</template></label>
                <span class="clear-wrapper" v-if="field.type==='radio'&&!field.required" @click="value[field.name]=null">
                    <i class="fa fa-eraser"></i><span>Clear field</span>
                </span>
                <component :is="get_component_name(field)" v-model="value[field.name]" :field="field" @input="$emit('clearerror', field.name)"></component>
                <div v-if="field.subtext" v-html="field.subtext"></div>
                <div class="error-text" v-if="errors[field.name]">{{errors[field.name]}}</div>
            </div>
        </transition-group>
    </div>
</template>

<script>
    import vTextField from '@/components/form/inputs/v-text-field.vue'
    import vRadioField from '@/components/form/inputs/v-radio-field.vue'
    import vSelectField from '@/components/form/inputs/v-select-field.vue'
    import vTextareaField from '@/components/form/inputs/v-textarea-field.vue'
    import vAuthorField from '@/components/form/inputs/v-author-field.vue'
    import vCheckField from '@/components/form/inputs/v-check-field.vue'
    import vPrgField from '@/components/form/inputs/v-prg-field.vue'
    import Datepicker from 'vuejs-datepicker';
    export default {
        name: 'v-form',
        props:['formdef', 'errors', 'value'],
        components:{
            'v-text-field':vTextField,
            'v-mail-field':vTextField,
            'v-radio-field':vRadioField,
            'v-select-field':vSelectField,
            'v-textarea-field':vTextareaField,
            'v-author-field':vAuthorField,
            'v-check-field':vCheckField,
            'v-date-field':Datepicker,
            'v-prg-field':vPrgField
        },
        methods:{
            get_component_name(field){
                return 'v-'+field.type+'-field';
            },
            field_shown(field){
                // If this field does not depend on any other, show
                if(!('depends' in field)) return true;
                // Loop dependencies
                for(var check_idx in field.depends){
                    var field_name =  field.depends[check_idx]["field"];
                    var field_value = field.depends[check_idx]["value"];
                    // If ANY of dependencies matches, show
                    if(this.value[field_name] == field_value) return true;
                }
                // If field is not to be shown, clear it
                this.$emit('update', { ...this.value, [this.value[field.name]]: null});
                return false;
            }
        },
    }
</script>

<style scoped lang="scss">
    .field-wrapper{
        border:1px solid #bebebe;
        border-left:2px solid #bebebe;
        padding:10px;
        margin:5px;
        &.inset{
            margin-left:30px;
        }
        //display:none;
        &.visible{ display: block; }
        &.error{
            border-left-color: red;
        }
        label{
            font-size:1.2em;
        }
        .error-text{
            color:red;
            font-size:1.2em;
        }
    }

    .clear-wrapper{
        color:red;
        margin:0 5px;
        cursor:pointer;
        span{opacity:0; margin-left:5px;}
        &:hover{span{opacity:100;}}
    }

    //Transition
    .slide-fade-enter-active {
      transition: all .3s ease;
    }
    .slide-fade-leave-active {
      transition: all .3s ease;
    }
    .slide-fade-enter, .slide-fade-leave-to{
      transform: translateX(-10px);
      opacity: 0;
    }
</style>
